import type {LucideIcon} from "lucide-react";
import {AlertCircle} from "lucide-react";

import {Alert, AlertDescription} from "@/components/ui/alert";
import {DialogDescription, DialogHeader, DialogTitle} from "@/components/ui/dialog";
import {cn} from "@/lib/utils";

export const complianceGateDialogContentClassName =
  "max-h-[min(90dvh,calc(100%-2rem))] gap-0 overflow-y-auto p-6 sm:max-w-md";

type ComplianceGateDialogHeaderProps = {
  icon: LucideIcon;
  title: string;
  description?: string;
  className?: string;
};

export function ComplianceGateDialogHeader({
  icon: Icon,
  title,
  description,
  className,
}: ComplianceGateDialogHeaderProps) {
  return (
    <DialogHeader className={cn("gap-1 p-0 text-left", className)}>
      <div className="flex items-start gap-3">
        <div className="shrink-0 rounded-full bg-primary/10 p-2">
          <Icon className="size-4 text-primary" />
        </div>
        <div className="min-w-0 flex flex-1 flex-col gap-1">
          <DialogTitle className="text-base leading-snug">{title}</DialogTitle>
          {description ? <DialogDescription>{description}</DialogDescription> : null}
        </div>
      </div>
    </DialogHeader>
  );
}

type ComplianceGateActionErrorProps = {
  message: string;
};

export function ComplianceGateActionError({message}: ComplianceGateActionErrorProps) {
  return (
    <Alert variant="destructive">
      <AlertCircle className="size-4" />
      <AlertDescription>{message}</AlertDescription>
    </Alert>
  );
}
